import { all } from "redux-saga/effects";
import { analyticsSaga } from "./analytics";
import { appSaga } from "./app";

export function* rootSaga() {
  yield all([analyticsSaga(), appSaga()]);
}
